export default function(value) {
	const created = new Date(value);
	const date = Intl.DateTimeFormat("fr-ca", { year: "numeric", month: "2-digit", day: "2-digit" }).format(created);
	const time = Intl.DateTimeFormat("en", { hour: "2-digit", minute: "2-digit", hour12: false }).format(created);
	return date + " " + time;
}
